import React, { useEffect, useState, Fragment, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import ShopifyIntegrationActions from '@Actions/integrations/shopifyIntegrationActions';
import {
  Checkbox, Select, Alert,
} from 'antd';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import documentUINamesConstant from '../../../../../../../apis/documentUINamesConstant';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';

const { Option } = Select;
/**
 *
 */
const SyncSetup = ({
  user, getShopifyConnections, shopifyConnections, connectTenantToShopifyLocation, connectTenantToShopifyLocationLoading, setStep, getShopifyConnectionsLoading,
}) => {
  const [isProductWebhook, setIsProductWebhook] = useState('');
  const [isOrderWebhook, setIsOrderWebhook] = useState('');
  const [isFulfillmentWebhook, setIsFulfillmentWebhook] = useState('');
  const [isInventoryWebhook, setIsInventoryWebhook] = useState('');
  // const [isRefundWebhook, setIsRefundWebhook] = useState('');
  const [selectInvoicePlace, setSelectInvoicePlace] = useState('GEN_INVOICE_AT_SALES_ORDER');

  const documentUINames = useMemo(() => documentUINamesConstant(user), [user]);

  const invoiceGenList = [{
    // label: 'Generate Invoice at Sales Order', value: 'GEN_INVOICE_AT_SALES_ORDER',
    label: `Generate Invoice at ${documentUINames.salesOrderUIName}`, value: 'GEN_INVOICE_AT_SALES_ORDER',
  },
  {
    label: 'Generate Invoice at Fulfillment', value: 'GEN_INVOICE_AT_FULFILLMENT',
  },
  ];

  useEffect(() => {
    getShopifyConnections(user?.tenant_info?.org_id, (data) => {
      const configurationData = data?.find((connection) => connection?.is_connected)?.configuration;
      if (configurationData) {
        setIsProductWebhook(configurationData?.product_webhook);
        setIsOrderWebhook(configurationData?.order_webhook);
        setIsFulfillmentWebhook(configurationData?.fulfillment_webhook);
        setIsInventoryWebhook(configurationData?.inventory_webhook);
        setIsInventoryWebhook(configurationData?.inventory_webhook);
        // setIsRefundWebhook(configurationData?.refund_webhook);
        if (configurationData?.generate_invoice_method) {
          setSelectInvoicePlace(configurationData?.generate_invoice_method);
        }
      }
    });
  }, []);

  const shopName = shopifyConnections?.find((connection) => connection?.is_connected)?.shop_name;

  const tenantIntegrations = shopifyConnections?.find((connection) => connection?.is_connected)?.tenant_integrations;

  const oldConfiguration = shopifyConnections?.find((connection) => connection?.is_connected)?.configuration;

  const productSyncAt = shopifyConnections?.[0]?.product_sync_at;

  const handleSubmit = () => {
    const payload = {
      org_id: user?.tenant_info?.org_id,
      shop_name: shopName,
    };

    const configuration = {
      ...oldConfiguration,
      product_webhook: isProductWebhook,
      order_webhook: isOrderWebhook,
      fulfillment_webhook: isFulfillmentWebhook,
      inventory_webhook: isInventoryWebhook,
      // refund_webhook: isRefundWebhook,
      generate_invoice_method: selectInvoicePlace,
    };

    payload.tenant_integrations = tenantIntegrations;
    payload.configuration = configuration;

    connectTenantToShopifyLocation(payload, () => {
      setStep(4);
    });
  };

  return (
    <Fragment>
      { getShopifyConnectionsLoading
        ? (
          <div className="shopify-integration__loader__wrapper">

            { [...Array(5).keys()].map((item) => (
              <div key={item} className="shopify-integration__loader-row">
                <div className="loadingBlock  shopify-integration__loader__line1" />
                <div className="loadingBlock  shopify-integration__loader__line2" />
                <div className="loadingBlock  shopify-integration__loader__line3" />
              </div>
            ))}
            <div className="loadingBlock shopify-integration__loader__line-btn1" />
            <div className="loadingBlock shopify-integration__loader__line-btn2" />
          </div>
        )
        : (
          <div className="shopify__sync-setup-wrapper">

            {productSyncAt && (
              <div className="shopify__sync-setup-warning">
                <Alert
                  message="Products are in syncing process please wait you cannot proceed to the next step."
                  type="info"
                  showIcon
                  className=""
                />
              </div>
            )}

            <div className="shopify__sync-setup-header">
              Order info, fulfillment state and inventory sync going forward.
            </div>

            <div className="shopify__sync-setup-entity">
              <div className="shopify__sync-setup-entity-info">
                We can automatically synchronize order changes, fulfillment states and inventory levels between Procuzy and Shopify in real time. Please choose your preferences below.
              </div>
              <div className="shopify__sync-setup-check">
                <Checkbox
                  checked={isProductWebhook}
                  onChange={(e) => {
                    setIsProductWebhook(e.target.checked);
                  }}
                  disabled={connectTenantToShopifyLocationLoading || productSyncAt}
                >
                  Yes, synchronize product changes from Shopify to Procuzy.
                </Checkbox>
              </div>
              <div className="shopify__sync-setup-check">
                <Checkbox
                  checked={isOrderWebhook}
                  onChange={(e) => {
                    setIsOrderWebhook(e.target.checked);
                  }}
                  disabled={connectTenantToShopifyLocationLoading || productSyncAt}
                >
                  Yes, synchronize order changes from Shopify to Procuzy.
                </Checkbox>
              </div>
              <div className="shopify__sync-setup-check">
                <div className="shopify__sync-setup-check__select">
                  <PRZSelect
                    value={selectInvoicePlace}
                    filterOption={false}
                    onChange={(value) => setSelectInvoicePlace(value)}
                    style={{
                      width: '250px',
                      fontSize: '13px',
                      marginRight: '10px',
                      marginTop: '0px',
                    }}
                    disabled={connectTenantToShopifyLocationLoading || productSyncAt}

                  >
                    {invoiceGenList?.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item.label}
                      </Option>
                    ))}
                  </PRZSelect>
                  <div className="shopify__sync-setup-check__text" style={{ fontSize: '13px' }}>Choose where to Generate Invoices</div>
                </div>
              </div>
              <div className="shopify__sync-setup-check">
                <Checkbox
                  checked={isFulfillmentWebhook}
                  onChange={(e) => {
                    setIsFulfillmentWebhook(e.target.checked);
                  }}
                  disabled={connectTenantToShopifyLocationLoading || productSyncAt}
                >
                  Yes, synchronize fulfillment state between Shopify and Procuzy.
                </Checkbox>
              </div>
              {/* <div className="shopify__sync-setup-check">
                <Checkbox
                  checked={isRefundWebhook}
                  onChange={(e) => {
                    setIsRefundWebhook(e.target.checked);
                  }}
                  disabled={connectTenantToShopifyLocationLoading || !isFulfillmentWebhook}
                >
                  Yes, synchronize refunds between Shopify and Procuzy.
                </Checkbox>
              </div> */}
              <div className="shopify__sync-setup-check">
                <Checkbox
                  checked={isInventoryWebhook}
                  onChange={(e) => {
                    setIsInventoryWebhook(e.target.checked);
                  }}
                  disabled={connectTenantToShopifyLocationLoading || productSyncAt}
                >
                  Yes, synchronize stock levels from Procuzy  to Shopify.
                </Checkbox>
              </div>
              {isInventoryWebhook && (
                <div className="shopify__sync-setup-inner-check">
                  <div className="shopify__sync-setup-check">
                    <Checkbox
                      checked
                      disabled
                    />
                    <span style={{ marginLeft: '8px', fontSize: '13px' }}>
                      Commitments from orders created in Procuzy reduce the availability of stock in shopify.
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className="ant-row">
            &nbsp;&nbsp;
              <H3Button
                text="Back"
                buttonType={defaultButtonTypes.BLUE_BORDERED}
                onClick={() => setStep(2)}
                customClass="shopify__sync-setup-submit"
                disabled={connectTenantToShopifyLocationLoading}
              />
              &nbsp;&nbsp;
              <H3Button
                text="Next Step"
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                onClick={() => handleSubmit()}
                customClass="shopify__sync-setup-submit"
                isLoading={connectTenantToShopifyLocationLoading}
                disabled={connectTenantToShopifyLocationLoading || productSyncAt}
              />
            </div>
          </div>
        )}
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, ShopifyIntegrationReducers }) => ({
  user: UserReducers.user,
  shopifyConnections: ShopifyIntegrationReducers.shopifyConnections,
  connectTenantToShopifyLocationLoading: ShopifyIntegrationReducers.connectTenantToShopifyLocationLoading,
});
const mapDispatchToProps = (dispatch) => ({
  getShopifyConnections: (orgId, callback) => dispatch(ShopifyIntegrationActions.getShopifyConnections(orgId, callback)),
  connectTenantToShopifyLocation: (payload, callback) => dispatch(ShopifyIntegrationActions.connectTenantToShopifyLocation(payload, callback)),
});

SyncSetup.propTypes = {
  user: PropTypes.any,
  getShopifyConnectionsLoading: PropTypes.bool,
  getShopifyConnections: PropTypes.func,
  connectTenantToShopifyLocation: PropTypes.func,
  connectTenantToShopifyLocationLoading: PropTypes.bool,
  shopifyConnections: PropTypes.any,
  setStep: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SyncSetup));
